/* dd-cine.js — Desert Drip cinematic homepage behaviour.
   Every component wires per element (data-ddc-wired), and re-wires on shopify:section:load so the
   theme editor keeps working. Scroll-driven effects share one rAF tick. */
(function () {
  'use strict';
  if (window.__ddcBoot) return; // the FILE loads once; wiring below is per element, not global
  window.__ddcBoot = true;

  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var DESIGN = !!(window.Shopify && window.Shopify.designMode);
  var lerp = function (a, b, t) { return a + (b - a) * t; };
  var clamp = function (v) { return Math.min(1, Math.max(0, v)); };
  var seg = function (p, a, b) { return clamp((p - a) / (b - a)); };

  /* ---------- shared scroll tick ---------- */
  var subs = [];
  var ticking = false;
  function onTick(el, fn) { subs.push({ el: el, fn: fn }); fn(); }
  function tick() {
    ticking = false;
    subs = subs.filter(function (s) { return s.el.isConnected; });
    for (var i = 0; i < subs.length; i++) subs[i].fn();
  }
  function requestTick() { if (!ticking) { ticking = true; requestAnimationFrame(tick); } }
  window.addEventListener('scroll', requestTick, { passive: true });
  window.addEventListener('resize', requestTick);

  /* ---------- smooth scroll (off in the editor and for reduced motion) ---------- */
  var lenis = null;
  function initLenis() {
    if (lenis || RM || DESIGN || !window.Lenis) return;
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    if (!document.querySelector('[data-ddc-smooth="true"]')) return;
    lenis = new window.Lenis({ lerp: 0.09, wheelMultiplier: 1, smoothWheel: true });
    lenis.on('scroll', requestTick);
    (function raf(t) { lenis.raf(t); requestAnimationFrame(raf); })();
    window.ddcLenis = lenis;
  }

  function once(el, key) {
    if (el.dataset['ddc' + key]) return false;
    el.dataset['ddc' + key] = '1';
    return true;
  }

  /* ---------- reveals ---------- */
  var revealIO = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('in');
      revealIO.unobserve(e.target);
    });
  }, { threshold: 0.16 }) : null;
  function initReveals(root) {
    root.querySelectorAll('.ddc .rise, .ddc .kin, .ddc [data-stagger], .rise, .kin, [data-stagger]').forEach(function (el) {
      if (!el.closest('.ddc') || !once(el, 'Reveal')) return;
      if (!revealIO || RM || DESIGN) { el.classList.add('in'); return; }
      revealIO.observe(el);
    });
  }

  /* ---------- atmosphere: day to night sky, hero scene, clouds, motes ---------- */
  var GK = [
    { k: 0, s: [[236, 182, 150], [246, 208, 172], [247, 212, 152]] },
    { k: 0.14, s: [[248, 224, 216], [251, 238, 225], [247, 216, 172]] },
    { k: 0.32, s: [[246, 210, 182], [250, 232, 210], [244, 200, 146]] },
    { k: 0.5, s: [[247, 214, 206], [251, 233, 216], [245, 204, 160]] },
    { k: 0.68, s: [[243, 192, 160], [249, 223, 194], [240, 187, 130]] },
    { k: 0.85, s: [[232, 166, 152], [245, 207, 182], [233, 176, 124]] },
    { k: 1, s: [[170, 108, 126], [228, 168, 156], [222, 154, 108]] }
  ];
  var NIGHT = [[9, 12, 40], [24, 20, 58], [44, 34, 74]];
  function dayStops(p) {
    var i = 0;
    while (i < GK.length - 1 && p > GK[i + 1].k) i++;
    var a = GK[i], b = GK[Math.min(i + 1, GK.length - 1)];
    var t = b.k > a.k ? clamp((p - a.k) / (b.k - a.k)) : 0;
    return [0, 1, 2].map(function (j) {
      return [lerp(a.s[j][0], b.s[j][0], t), lerp(a.s[j][1], b.s[j][1], t), lerp(a.s[j][2], b.s[j][2], t)];
    });
  }
  function mix(c, n, t) { return 'rgb(' + Math.round(lerp(c[0], n[0], t)) + ',' + Math.round(lerp(c[1], n[1], t)) + ',' + Math.round(lerp(c[2], n[2], t)) + ')'; }
  function skyGrad(p, np) {
    var d = dayStops(p);
    var npMid = clamp((np - 0.28) / 0.28), npBot = np * 0.9;
    return 'linear-gradient(180deg,' + mix(d[0], NIGHT[0], np) + ' 0%,' + mix(d[1], NIGHT[1], npMid) + ' 52%,' + mix(d[2], NIGHT[2], npBot) + ' 100%)';
  }
  function initAtmosphere(root) {
    root.querySelectorAll('[data-ddc-atmos]').forEach(function (atmos) {
      if (!once(atmos, 'Atmos')) return;
      var sky = atmos.querySelector('[data-sky]');
      var stars = atmos.querySelector('[data-stars]');
      var moon = atmos.querySelector('[data-moon]');
      var vig = atmos.querySelector('[data-vignette]');
      var dust = atmos.querySelector('[data-dust]');
      var scene = atmos.querySelector('[data-heroscene]');
      if (stars && !stars.children.length) {
        var h = '';
        for (var i = 0; i < 80; i++) h += '<span class="star" style="left:' + (Math.random() * 100) + '%;top:' + (Math.random() * 66) + '%;width:' + (Math.random() * 2 + 1) + 'px;height:' + (Math.random() * 2 + 1) + 'px;animation-delay:' + (Math.random() * 4) + 's"></span>';
        stars.innerHTML = h;
      }
      var motes = [];
      if (dust && !dust.children.length && !RM) {
        var m = '';
        for (var j = 0; j < 18; j++) m += '<span class="mote" data-sp="' + (Math.random() * 0.5 + 0.2) + '" style="left:' + (Math.random() * 100) + '%;top:' + (Math.random() * 100) + '%;width:' + (Math.random() * 3 + 1.5) + 'px;height:' + (Math.random() * 3 + 1.5) + 'px;opacity:' + (Math.random() * 0.4 + 0.14) + '"></span>';
        dust.innerHTML = m;
        motes = [].slice.call(dust.querySelectorAll('.mote'));
        var t = 0;
        (function drift() {
          if (!atmos.isConnected) return;
          t += 0.016;
          motes.forEach(function (mo, k) {
            var sp = parseFloat(mo.dataset.sp);
            mo.style.transform = 'translate(' + (Math.sin(t * sp + k) * 12) + 'px,' + (Math.cos(t * sp * 0.7 + k) * 9 - (t * sp * 5) % 36) + 'px)';
          });
          requestAnimationFrame(drift);
        })();
      }
      var clouds = [].slice.call(document.querySelectorAll('[data-ddc-cloud]'));
      function base() { clouds.forEach(function (c) { c._sp = parseFloat(c.dataset.sp); c._op = parseFloat(c.dataset.op); c._base = c.offsetTop; }); }
      base();
      window.addEventListener('resize', base);
      window.addEventListener('load', base);
      onTick(atmos, function () {
        var max = document.documentElement.scrollHeight - innerHeight;
        var y = window.scrollY || window.pageYOffset;
        var p = max > 0 ? y / max : 0;
        var closing = document.querySelector('.ddc-closing');
        var npA = 0;
        if (closing) { var cr = closing.getBoundingClientRect(); npA = (innerHeight - cr.top) / (innerHeight * 0.85); }
        /* night must be in by the time the first white-text section arrives (on phones the page is tall, so a page-fraction timeline hit that section at dusk and white copy measured 2.9:1) */
        var firstNight = document.querySelector('.ddc-section.ddc-tone-night');
        var npB = 0;
        if (firstNight) { var fr = firstNight.getBoundingClientRect(); npB = (innerHeight * 0.9 - fr.top) / (innerHeight * 0.5); }
        var np = clamp(Math.max(seg(p, 0.5, 1), npA, npB));
        /* the sky is a full-screen fixed layer; rewriting its gradient every tick repaints the whole screen. Only touch it when the value moved. */
        if (sky && (Math.abs(p - (atmos._lp || 0)) > 0.0015 || Math.abs(np - (atmos._lnp || 0)) > 0.0015 || !atmos._lp)) { atmos._lp = p || 0.00001; atmos._lnp = np; sky.style.background = skyGrad(p, np); }
        if (scene) scene.style.opacity = Math.max(0, 1 - (y / (innerHeight * 0.72))).toFixed(3);
        if (stars) stars.style.opacity = np;
        if (moon) { var small = innerWidth < 600; moon.style.opacity = small ? np * 0.75 : np; moon.style.transform = 'translateY(' + (small ? lerp(3, 9, np) : lerp(18, 70, np)) + 'vh)'; } // phones: keep the moon in the sky above the copy
        if (vig) vig.style.opacity = np * 0.9;
        for (var c = 0; c < clouds.length; c++) {
          var im = clouds[c];
          var d = y - im._base;
          if (d < -innerHeight) d = -innerHeight; else if (d > innerHeight) d = innerHeight;
          im.style.transform = 'translate3d(0,' + (d * im._sp).toFixed(1) + 'px,0)';
          im.style.opacity = (im._op * (1 - np)).toFixed(3);
        }
      });
    });
  }

  /* ---------- cursor + magnetic buttons (desktop pointer only) ---------- */
  function initCursor(root) {
    var dot = document.querySelector('[data-ddc-cursor]');
    var ring = document.querySelector('[data-ddc-cursor-ring]');
    if (!window.matchMedia('(hover:hover)').matches || RM) return;
    if (dot && ring && once(dot, 'Cursor')) {
      var mx = innerWidth / 2, my = innerHeight / 2, rx = mx, ry = my;
      window.addEventListener('mousemove', function (e) { mx = e.clientX; my = e.clientY; dot.style.transform = 'translate(' + mx + 'px,' + my + 'px) translate(-50%,-50%)'; });
      (function loop() { rx += (mx - rx) * 0.18; ry += (my - ry) * 0.18; ring.style.transform = 'translate(' + rx + 'px,' + ry + 'px) translate(-50%,-50%)'; requestAnimationFrame(loop); })();
    }
    root.querySelectorAll('.ddc a, .ddc button, .ddc summary, .ddc [data-magnetic]').forEach(function (el) {
      if (!once(el, 'Hot')) return;
      if (ring) {
        el.addEventListener('mouseenter', function () { ring.classList.add('hot'); });
        el.addEventListener('mouseleave', function () { ring.classList.remove('hot'); });
      }
      if (el.hasAttribute('data-magnetic')) {
        el.addEventListener('mousemove', function (e) { var r = el.getBoundingClientRect(); el.style.transform = 'translate(' + ((e.clientX - r.left - r.width / 2) * 0.28) + 'px,' + ((e.clientY - r.top - r.height / 2) * 0.4) + 'px)'; });
        el.addEventListener('mouseleave', function () { el.style.transform = ''; });
      }
    });
  }

  /* ---------- hero sand stage: rise on load, sink into the dune on scroll ---------- */
  function initSand(root) {
    root.querySelectorAll('[data-sand-stage] .sand__stage').forEach(function (st) {
      if (!once(st, 'Sand')) return;
      var items = [].slice.call(st.querySelectorAll('.sand__item'));
      setTimeout(function () { st.classList.add('in'); }, RM || DESIGN ? 0 : 400);
      onTick(st, function () {
        var y = window.scrollY || window.pageYOffset;
        if (y > 4) st.classList.add('sinking');
        if (RM) return;
        items.forEach(function (el) { el.style.setProperty('--sink', (y * (parseFloat(el.dataset.sink) || 0.1)).toFixed(1) + 'px'); });
      });
    });
  }

  /* ---------- prickly pear: skin peels away top-down as you scroll ---------- */
  function initPear(root) {
    root.querySelectorAll('[data-pear]').forEach(function (pear) {
      if (!once(pear, 'Pear')) return;
      var sec = pear.closest('section') || pear;
      onTick(pear, function () {
        var r = sec.getBoundingClientRect();
        var frac = (r.top + r.height / 2) / innerHeight;
        pear.style.setProperty('--reveal', clamp((0.9 - frac) / 0.5).toFixed(3));
      });
    });
  }

  /* ---------- pinned two-harvest panel ---------- */
  function initPin(root) {
    root.querySelectorAll('[data-sf-night]').forEach(function (el) {
      if (!once(el, 'Pin')) return;
      var pin = el.closest('[data-sf-pin]') || el;
      onTick(el, function () {
        var r = pin.getBoundingClientRect(), dist = r.height - innerHeight, t;
        if (dist > 40) { t = -r.top / dist; } else { var q = el.getBoundingClientRect(); t = (innerHeight * 0.5 - q.top) / q.height; }
        var p = clamp((clamp(t) - 0.28) / 0.42);
        p = p * p * (3 - 2 * p);
        el.style.setProperty('--open', p.toFixed(3));
        el.classList.toggle('is-night', p > 0.5);
      });
    });
  }

  /* ---------- enemy stack: strike lines one by one, then the punch ---------- */
  function initStack(root) {
    root.querySelectorAll('[data-stack]').forEach(function (wrap) {
      if (!once(wrap, 'Stack')) return;
      var lines = [].slice.call(wrap.querySelectorAll('.ddc-stack li'));
      function play() {
        if (RM || DESIGN) { lines.forEach(function (l) { l.classList.add('hit'); }); wrap.classList.add('show'); return; }
        lines.forEach(function (l, i) { setTimeout(function () { l.classList.add('hit'); }, 300 + i * 260); });
        setTimeout(function () { wrap.classList.add('show'); }, 300 + lines.length * 260 + 200);
      }
      if (!revealIO) { play(); return; }
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { play(); io.disconnect(); } }); }, { threshold: 0.35 });
      io.observe(wrap);
    });
  }

  /* ---------- research accordion + plant plate ---------- */
  function initAnat(root) {
    root.querySelectorAll('[data-anat]').forEach(function (anat) {
      if (!once(anat, 'Anat')) return;
      var plate = anat.querySelector('.dd-sf__plate');
      var items = [].slice.call(anat.querySelectorAll('.dd-sf__item'));
      items.forEach(function (it) {
        it.querySelector('.dd-sf__q').addEventListener('click', function () {
          var open = it.classList.contains('is-open');
          items.forEach(function (o) { o.classList.remove('is-open'); o.querySelector('.dd-sf__q').setAttribute('aria-expanded', 'false'); });
          if (!open) { it.classList.add('is-open'); this.setAttribute('aria-expanded', 'true'); }
          if (plate) plate.setAttribute('data-active', open ? 'whole' : it.dataset.part);
        });
      });
    });
  }

  /* ---------- compare chart: bars come from section blocks via JSON ---------- */
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function initCompare(root) {
    root.querySelectorAll('[data-compare]').forEach(function (chart) {
      if (!once(chart, 'Compare')) return;
      var dataEl = chart.querySelector('[data-compare-data]');
      if (!dataEl) return;
      var D;
      try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }
      var rows = chart.querySelector('[data-rows]'), ticks = chart.querySelector('[data-ticks]'), axis = chart.querySelector('[data-axis]');
      var tabs = [].slice.call(chart.querySelectorAll('.dd-sf__tab'));
      function render(key) {
        var m = D.metrics[key];
        if (!m) return;
        var bars = D.bars.filter(function (b) { return b.metric === key; });
        rows.innerHTML = bars.map(function (b) {
          var w = Math.round(Math.min(1, b.value / m.max) * 10000) / 100;
          return '<div class="dd-sf__row' + (b.highlight ? ' dd-sf__row--hero' : '') + '" style="--w:' + w + '%"><span class="dd-sf__bar"></span><span class="dd-sf__val' + (w < 45 ? ' dd-sf__val--out' : '') + '"><b>' + esc(b.value + m.unit) + '</b></span><span class="dd-sf__crop">' + esc(b.label) + '</span></div>';
        }).join('');
        ticks.innerHTML = m.ticks.map(function (t) { return '<span>' + esc(t) + '</span>'; }).join('');
        axis.textContent = m.axis;
        if (chart.classList.contains('in')) { chart.classList.remove('in'); void chart.offsetWidth; chart.classList.add('in'); }
      }
      tabs.forEach(function (t) {
        t.addEventListener('click', function () {
          tabs.forEach(function (o) { o.classList.toggle('is-active', o === t); o.setAttribute('aria-selected', o === t ? 'true' : 'false'); });
          render(t.dataset.metric);
        });
      });
      render(tabs.length ? tabs[0].dataset.metric : Object.keys(D.metrics)[0]);
    });
  }

  /* ---------- ingredient scroller arrow ---------- */
  function initIngredients(root) {
    root.querySelectorAll('[data-ig-grid]').forEach(function (grid) {
      if (!once(grid, 'Ig')) return;
      var btn = grid.parentElement.querySelector('[data-ig-next]');
      if (!btn) return;
      function card() { var c = grid.querySelector('.dd-ig__cell'); return c ? c.getBoundingClientRect().width + 20 : 320; }
      function upd() { btn.hidden = grid.scrollLeft >= grid.scrollWidth - grid.clientWidth - 4 || grid.scrollWidth <= grid.clientWidth + 4; }
      btn.addEventListener('click', function () { grid.scrollBy({ left: card() * 1.5, behavior: 'smooth' }); });
      grid.addEventListener('scroll', upd, { passive: true });
      window.addEventListener('resize', upd);
      setTimeout(upd, 300);
      upd();
    });
  }

  /* ---------- mobile sticky buy button ---------- */
  function initMobileCta(root) {
    root.querySelectorAll('[data-ddc-mcta]').forEach(function (btn) {
      if (!once(btn, 'Mcta')) return;
      var after = document.querySelector(btn.dataset.mctaAfter || '#buy-box');
      var until = document.querySelector(btn.dataset.mctaUntil || '#buy');
      if (!after) return;
      btn.hidden = false;
      onTick(btn, function () {
        var a = after.getBoundingClientRect();
        var past = a.bottom < 0;
        var atEnd = until ? until.getBoundingClientRect().top < innerHeight * 0.6 : false;
        btn.classList.toggle('is-on', past && !atEnd);
      });
    });
  }

  /* ---------- UGC: lightweight poster cards, tap for the full-screen player ---------- */
  function initUgc(root) {
    root.querySelectorAll('[data-ugc]').forEach(function (wrap) {
      if (!once(wrap, 'Ugc')) return;
      var track = wrap.querySelector('[data-ugc-track]');
      var tiles = [].slice.call(wrap.querySelectorAll('[data-ugc-open]'));
      var section = wrap.closest('.ddc-section') || wrap;
      var lb = section.querySelector('[data-ugc-lightbox]');
      var lbv = lb && lb.querySelector('[data-ugc-lb-video]');
      var lbm = lb && lb.querySelector('[data-ugc-lb-meta]');
      var cur = -1;
      /* arrows (desktop) */
      var prev = wrap.querySelector('[data-ugc-prev]'), next = wrap.querySelector('[data-ugc-next]');
      function tileW() { var t = track.querySelector('.ddc-ugc__tile'); return t ? t.getBoundingClientRect().width + 14 : 250; }
      function upd() { if (!track) return; var end = track.scrollLeft >= track.scrollWidth - track.clientWidth - 4 || track.scrollWidth <= track.clientWidth + 4; if (next) next.hidden = end; if (prev) prev.hidden = track.scrollLeft <= 4; }
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: tileW() * 2, behavior: 'smooth' }); });
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -tileW() * 2, behavior: 'smooth' }); });
      if (track) { track.addEventListener('scroll', upd, { passive: true }); window.addEventListener('resize', upd); setTimeout(upd, 300); upd(); }
      /* lightbox */
      if (!lb || !lbv) return;
      var lbPrev = lb.querySelector('[data-ugc-lb-prev]'), lbNext = lb.querySelector('[data-ugc-lb-next]'), lbClose = lb.querySelector('[data-ugc-close]');
      var lastFocus = null;
      function show(i) {
        if (i < 0 || i >= tiles.length) return;
        cur = i;
        var t = tiles[i];
        lbv.pause();
        lbv.src = window.matchMedia('(max-width: 749px)').matches && t.dataset.srcMobile ? t.dataset.srcMobile : t.dataset.src;
        if (t.dataset.poster) lbv.poster = t.dataset.poster;
        lbv.muted = false;
        lbv.currentTime = 0;
        var p = lbv.play(); if (p && p.catch) p.catch(function () { lbv.controls = true; });
        if (lbm) lbm.textContent = [t.dataset.handle, t.dataset.caption].filter(Boolean).join(' · ');
        if (lbPrev) lbPrev.disabled = i === 0;
        if (lbNext) lbNext.disabled = i === tiles.length - 1;
      }
      function open(i) {
        lastFocus = document.activeElement;
        lb.hidden = false;
        requestAnimationFrame(function () { lb.classList.add('is-open'); });
        document.body.classList.add('ddc-lb-open');
        show(i);
        if (lbClose) lbClose.focus();
      }
      function close() {
        lb.classList.remove('is-open');
        lbv.pause(); lbv.removeAttribute('src'); lbv.load();
        document.body.classList.remove('ddc-lb-open');
        setTimeout(function () { lb.hidden = true; }, 220);
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      }
      tiles.forEach(function (t, i) { t.addEventListener('click', function () { open(i); }); });
      if (lbClose) lbClose.addEventListener('click', close);
      if (lbPrev) lbPrev.addEventListener('click', function () { show(cur - 1); });
      if (lbNext) lbNext.addEventListener('click', function () { show(cur + 1); });
      lb.addEventListener('click', function (e) { if (e.target === lb) close(); });
      document.addEventListener('keydown', function (e) {
        if (lb.hidden) return;
        if (e.key === 'Escape') close();
        else if (e.key === 'ArrowRight') show(cur + 1);
        else if (e.key === 'ArrowLeft') show(cur - 1);
      });
      var sx = null;
      lb.addEventListener('pointerdown', function (e) { sx = e.clientX; }, { passive: true });
      lb.addEventListener('pointerup', function (e) { if (sx === null) return; var dx = e.clientX - sx; sx = null; if (Math.abs(dx) > 60) show(cur + (dx < 0 ? 1 : -1)); }, { passive: true });
    });
  }

  /* ---------- reviews scroller arrows ---------- */
  function initReviews(root) {
    root.querySelectorAll('[data-rev-grid]').forEach(function (grid) {
      if (!once(grid, 'Rev')) return;
      var wrap = grid.parentElement;
      var prev = wrap.querySelector('[data-rev-prev]');
      var next = wrap.querySelector('[data-rev-next]');
      if (!next) return;
      function card() { var c = grid.querySelector('.ddc-rev__card'); return c ? c.getBoundingClientRect().width + 16 : 380; }
      function upd() {
        var atEnd = grid.scrollLeft >= grid.scrollWidth - grid.clientWidth - 4 || grid.scrollWidth <= grid.clientWidth + 4;
        next.hidden = atEnd;
        if (prev) prev.hidden = grid.scrollLeft <= 4;
      }
      next.addEventListener('click', function () { grid.scrollBy({ left: card(), behavior: 'smooth' }); });
      if (prev) prev.addEventListener('click', function () { grid.scrollBy({ left: -card(), behavior: 'smooth' }); });
      grid.addEventListener('scroll', upd, { passive: true });
      window.addEventListener('resize', upd);
      setTimeout(upd, 300);
      upd();
    });
  }

  /* ---------- taste meters fill when revealed ---------- */
  function initMeters(root) {
    root.querySelectorAll('.ddc .dd-te__fill[data-w]').forEach(function (f) {
      if (!once(f, 'Meter')) return;
      if (!revealIO || RM || DESIGN) { f.style.width = f.dataset.w + '%'; return; }
      var mio = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.style.width = e.target.dataset.w + '%'; mio.disconnect(); } }); }, { threshold: 0.4 });
      mio.observe(f);
    });
  }

  /* ---------- What's inside: hover (or tap) the Ingredients title for Jon's video ---------- */
  function initTip(root) {
    var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    root.querySelectorAll('[data-ddc-tip]').forEach(function (tip) {
      if (!once(tip, 'Tip')) return;
      var trig = tip.querySelector('.ddc-tip__trigger');
      var pop = tip.querySelector('[data-tip-pop]');
      var vid = tip.querySelector('[data-tip-video]');
      var snd = tip.querySelector('[data-tip-sound]');
      var bar = tip.querySelector('[data-tip-bar]');
      var open = false, pinned = false, leaveT = 0, hideT = 0;
      function setSound(on) {
        vid.muted = !on;
        snd.setAttribute('aria-pressed', on ? 'true' : 'false');
        snd.setAttribute('aria-label', on ? 'Turn sound off' : 'Turn sound on');
      }
      function show(withSound) {
        if (!vid.dataset.ddSourceLoaded) {
          vid.querySelectorAll('source[data-src]').forEach(function (source) {
            source.src = source.dataset.src;
          });
          vid.dataset.ddSourceLoaded = 'true';
          vid.load();
        }
        clearTimeout(leaveT); clearTimeout(hideT);
        if (withSound) setSound(true);
        if (!open) {
          open = true;
          pop.hidden = false;
          var hdr = document.querySelector('.shopify-section-group-header-group');
          var top = hdr ? Math.max(0, hdr.getBoundingClientRect().bottom) : 0;
          var triggerRect = trig.getBoundingClientRect();
          var popupHeight = pop.offsetHeight;
          var bottomEdge = innerHeight;
          var stickyCta = document.querySelector('.ddc-mcta.is-on');
          if (stickyCta) {
            var stickyRect = stickyCta.getBoundingClientRect();
            if (stickyRect.height && stickyRect.top > 0) bottomEdge = Math.min(bottomEdge, stickyRect.top);
          }
          var preferredTop = triggerRect.top - popupHeight - 14;
          if (preferredTop < top + 8) preferredTop = triggerRect.bottom + 14;
          var popupTop = Math.max(12, Math.min(preferredTop, bottomEdge - popupHeight - 12));
          tip.classList.toggle('is-below', popupTop >= triggerRect.bottom);
          tip.classList.toggle('is-detached', popupTop < triggerRect.bottom && popupTop + popupHeight > triggerRect.top);
          pop.style.top = (popupTop - tip.getBoundingClientRect().top) + 'px';
          pop.style.bottom = 'auto';
          void pop.offsetWidth;
          tip.classList.add('is-open');
          trig.setAttribute('aria-expanded', 'true');
        }
        if (vid.ended && !withSound) return;
        var p = vid.play();
        if (p && p.catch) p.catch(function () { setSound(false); vid.play().catch(function () {}); });
      }
      function hide() {
        if (!open) return;
        open = false; pinned = false;
        tip.classList.remove('is-open');
        trig.setAttribute('aria-expanded', 'false');
        vid.pause();
        setSound(false);
        hideT = setTimeout(function () { if (!open) pop.hidden = true; }, 320);
      }
      vid.addEventListener('timeupdate', function () {
        if (vid.duration) bar.style.width = (vid.currentTime / vid.duration * 100) + '%';
      });
      vid.addEventListener('ended', function () { clearTimeout(leaveT); pinned = true; });
      pop.querySelectorAll('.ddc-tip__social-link').forEach(function (link) {
        link.addEventListener('click', function () { pinned = true; vid.pause(); });
      });
      if (canHover) {
        [trig, pop].forEach(function (el) {
          el.addEventListener('mouseenter', function () { show(false); });
          el.addEventListener('mouseleave', function () {
            if (pinned) return;
            leaveT = setTimeout(hide, 220);
          });
        });
      }
      trig.addEventListener('click', function (e) {
        e.preventDefault();
        if (open && (pinned || !canHover)) { hide(); return; }
        pinned = true;
        show(true);
      });
      snd.addEventListener('click', function (e) {
        e.stopPropagation();
        pinned = true;
        setSound(vid.muted);
        if (vid.paused) vid.play().catch(function () {});
      });
      document.addEventListener('click', function (e) { if (open && !tip.contains(e.target)) hide(); });
      document.addEventListener('keydown', function (e) { if (open && e.key === 'Escape') { hide(); trig.focus(); } });
      window.addEventListener('scroll', function () {
        if (!open) return;
        var r = tip.getBoundingClientRect();
        if (r.bottom < -200 || r.top > innerHeight + 200) hide();
      }, { passive: true });
    });
  }

  /* ---------- user-requested product video ---------- */
function initOnDemandVideos(root) {
  root.querySelectorAll('[data-dd-video-on-demand]').forEach(function (wrapper) {
    if (!once(wrapper, 'OnDemandVideo')) return;
    var video = wrapper.querySelector('video');
    var button = wrapper.querySelector('[data-dd-video-play]');
    if (!video || !button) return;

    button.addEventListener('click', function () {
      if (!video.dataset.ddSourceLoaded) {
        video.querySelectorAll('source[data-src]').forEach(function (source) {
          source.src = source.dataset.src;
        });
        video.dataset.ddSourceLoaded = 'true';
        video.load();
      }
      video.controls = true;
      wrapper.classList.add('is-playing');
      button.hidden = true;
      var play = video.play();
      if (play && play.catch) {
        play.catch(function () { button.hidden = false; });
      }
    });
  });
}

  function init(root) {
    root = root || document;
    initOnDemandVideos(root);
    initReveals(root);
    initAtmosphere(root);
    initCursor(root);
    initSand(root);
    initPear(root);
    initPin(root);
    initStack(root);
    initAnat(root);
    initCompare(root);
    initIngredients(root);
    initReviews(root);
    initUgc(root);
    initTip(root);
    initMobileCta(root);
    initMeters(root);
    requestTick();
  }

  function boot() { init(document); initLenis(); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
